{{#> elements/_dt}}
  {{> elements/_label }}
{{/elements/_dt}}
<dd>
  {{> elements/_input type="email" title="Please enter a valid email" pattern="^\w+([\.\-]?\w+)*@\w+([\.\-]?\w+)*(\.\w{2,})+$" }}
</dd>
